module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-bottom-01.2.4039264d.jpg";